import stateNames from "$data/state_names.json";

const NATIONAL_ENTRY = {
  geoid: "00",
  state_name: "US",
  state_abbr: "US",
  description: "the US"
};

export const idMap = new Map([NATIONAL_ENTRY].concat(stateNames).map((d) => [d.geoid, d]));

/**
 * Get the abbreviation of a US state by its GEOID.
 * @param {string} geoid - The GEOID of the state.
 * @returns {string|null} - The abbreviation of the state, or null if not found.
 */
export function getStateAbb(geoid) {
  const entry = idMap.get(geoid);
  return entry ? entry.state_abbr : null;
}

/**
 * Get the full name of a US state by its GEOID.
 * @param {string} geoid - The GEOID of the state.
 * @returns {string|null} - The full name of the state, or null if not found.
 */
export function getStateName(geoid) {
  const entry = idMap.get(geoid);
  return entry ? entry.state_name : null;
}

/**
 * Get the formatted name of a congressional district by its GEOID.
 * @param {string} geoid - The GEOID of the congressional district (e.g., "0101" for Alabama's 1st district).
 * @returns {string} - The formatted name of the congressional district (e.g., "AL-01" or "Alabama District 1").
 */
export function getCdAbb(geoid) {
  const stateGeoid = geoid.slice(0, 2);
  const stateAbb = getAbb(stateGeoid);
  const cdNumber = geoid.slice(2);
  return `${stateAbb}-${cdNumber}`;
}

export function getAbb(geoid) {
  if (geoid.length === 2) {
    return getStateAbb(geoid);
  }
  return getCdAbb(geoid);
}

/**
 * Get the formatted name of a congressional district by its GEOID.
 * @param {string} geoid - The GEOID of the congressional district (e.g., "0101" for Alabama's 1st district).
 * @returns {string} - The formatted name of the congressional district (e.g., "AL-01" or "Alabama District 1").
 */
export function getCdName(geoid) {
  const stateGeoid = geoid.slice(0, 2);
  const stateName = getStateName(stateGeoid);
  const cdNumber = geoid.slice(2);
  return `${stateName} ${cdNumber}`;
}

export function getName(geoid) {
  if (geoid.length === 2) {
    return getStateName(geoid);
  }
  return getCdAbb(geoid);
}

export function getDescriptionName(geoid) {
  if (geoid == "00") {
    return NATIONAL_ENTRY.description;
  }
  return getName(geoid);
}
